var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { TaskTypes } from './constants';
var ChangeTracker = /** @class */ (function () {
    function ChangeTracker(prevState, scope) {
        this.prevState = prevState;
        this.scope = scope;
        this.nextNextTaskId = prevState.tasks.nextId;
        this.startedCacheTasks = {};
        this.startedRequestTasks = new Map();
    }
    ChangeTracker.prototype.buildNextState = function (nextRecords) {
        var e_1, _a, e_2, _b, e_3, _c;
        var prevState = this.prevState;
        var nextTasks = prevState.tasks;
        if (this.nextNextTaskId !== prevState.tasks.nextId ||
            this.nextPausedBy ||
            this.nextPending ||
            this.nextQueue) {
            nextTasks = {
                nextId: this.nextNextTaskId,
                pending: this.nextPending || __assign({}, prevState.tasks.pending),
                pausedBy: this.nextPausedBy || __assign({}, prevState.tasks.pausedBy),
                queue: this.nextQueue || __assign({}, prevState.tasks.queue),
            };
            // Add newly started tasks
            var startedCacheTaskTypes = Object.keys(this.startedCacheTasks);
            try {
                for (var startedCacheTaskTypes_1 = __values(startedCacheTaskTypes), startedCacheTaskTypes_1_1 = startedCacheTaskTypes_1.next(); !startedCacheTaskTypes_1_1.done; startedCacheTaskTypes_1_1 = startedCacheTaskTypes_1.next()) {
                    var type = startedCacheTaskTypes_1_1.value;
                    var _d = __read(this.startedCacheTasks[type], 3), taskId = _d[0], pointers = _d[1], states = _d[2];
                    nextTasks.queue[taskId] = 'start';
                    nextTasks.pending[taskId] = {
                        type: type,
                        scope: this.scope,
                        pointers: pointers,
                        taskId: taskId,
                        states: states,
                    };
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (startedCacheTaskTypes_1_1 && !startedCacheTaskTypes_1_1.done && (_a = startedCacheTaskTypes_1.return)) _a.call(startedCacheTaskTypes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                for (var _e = __values(this.startedRequestTasks.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var _g = __read(_f.value, 2), request = _g[0], started = _g[1];
                    var startedTypes = Object.keys(started);
                    try {
                        for (var startedTypes_1 = (e_3 = void 0, __values(startedTypes)), startedTypes_1_1 = startedTypes_1.next(); !startedTypes_1_1.done; startedTypes_1_1 = startedTypes_1.next()) {
                            var type = startedTypes_1_1.value;
                            var _h = __read(started[type], 2), taskId = _h[0], pointers = _h[1];
                            nextTasks.queue[taskId] = 'start';
                            nextTasks.pending[taskId] = {
                                type: type,
                                scope: this.scope,
                                pointers: pointers,
                                taskId: taskId,
                                request: request,
                            };
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (startedTypes_1_1 && !startedTypes_1_1.done && (_c = startedTypes_1.return)) _c.call(startedTypes_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return __assign(__assign({}, prevState), { data: nextRecords, tasks: nextTasks });
    };
    /**
     * Returns the taskId that the doc was added to
     */
    ChangeTracker.prototype.startCacheTask = function (type, pointer, state) {
        var tuple = this.startedCacheTasks[type];
        if (!tuple) {
            tuple = this.startedCacheTasks[type] = [
                String(this.nextNextTaskId++),
                [],
                [],
            ];
        }
        tuple[1].push(pointer);
        tuple[2].push(state);
        return tuple[0];
    };
    /**
     * Returns the taskId that the doc was added to
     */
    ChangeTracker.prototype.startRequestTasks = function (type, pointer, query) {
        var queryStartedTasks = this.startedRequestTasks.get(query);
        if (!queryStartedTasks) {
            this.startedRequestTasks.set(query, (queryStartedTasks = {}));
        }
        var tuple = queryStartedTasks[type];
        if (!tuple) {
            tuple = queryStartedTasks[type] = [String(this.nextNextTaskId++), []];
        }
        tuple[1].push(pointer);
        return tuple[0];
    };
    ChangeTracker.prototype.pausePointerTask = function (pointer, taskId) {
        this.nextPausedBy = this.nextPausedBy || __assign({}, this.prevState.tasks.pausedBy);
        this.nextQueue = this.nextQueue || __assign({}, this.prevState.tasks.queue);
        var pointers = this.nextPausedBy[taskId];
        if (pointers) {
            this.nextPausedBy[taskId] = pointers.concat(pointer);
        }
        else {
            this.nextPausedBy[taskId] = [pointer];
            this.nextQueue[taskId] = 'pause';
        }
    };
    ChangeTracker.prototype.removePointerFromTasks = function (pointer, prevTasks, nextTasks) {
        this.nextPausedBy = this.nextPausedBy || __assign({}, this.prevState.tasks.pausedBy);
        this.nextPending = this.nextPending || __assign({}, this.prevState.tasks.pending);
        this.nextQueue = this.nextQueue || __assign({}, this.prevState.tasks.queue);
        for (var i = 0; i < TaskTypes.length; i++) {
            var type = TaskTypes[i];
            var taskId = prevTasks[type];
            var nextTaskId = nextTasks && nextTasks[type];
            if (taskId && nextTaskId !== taskId) {
                var taskPointers = this.nextPending[taskId].pointers;
                var nextTaskPointers = removePointer(taskPointers, pointer);
                if (nextTaskPointers !== taskPointers) {
                    this.nextPending[taskId] = __assign(__assign({}, this.prevState.tasks.pending[taskId]), { pointers: nextTaskPointers });
                    if (nextTaskPointers.length === 0) {
                        delete this.nextPending[taskId];
                        delete this.nextPausedBy[taskId];
                        this.nextQueue[taskId] = 'stop';
                    }
                    else {
                        this.attemptToUnpauseTask(taskId, pointer);
                    }
                }
            }
        }
    };
    ChangeTracker.prototype.unpauseRefTask = function (pointer, taskId) {
        this.nextPausedBy = this.nextPausedBy || __assign({}, this.prevState.tasks.pausedBy);
        this.nextQueue = this.nextQueue || __assign({}, this.prevState.tasks.queue);
        this.attemptToUnpauseTask(taskId, pointer);
    };
    ChangeTracker.prototype.attemptToUnpauseTask = function (taskId, pointer) {
        var pausedRefs = this.nextPausedBy[taskId];
        if (pausedRefs) {
            if (pausedRefs === this.prevState.tasks.pausedBy[taskId]) {
                this.nextPausedBy[taskId] = pausedRefs = pausedRefs.slice();
            }
            var nextPausedRefs = removePointer(pausedRefs, pointer);
            if (nextPausedRefs.length === 0) {
                delete this.nextPausedBy[taskId];
                this.nextQueue[taskId] = 'start';
            }
            else {
                this.nextPausedBy[taskId] = nextPausedRefs;
            }
        }
    };
    return ChangeTracker;
}());
export { ChangeTracker };
function removePointer(pointers, pointerToRemove) {
    if (pointers.length === 1) {
        if (pointers[0].bucket === pointerToRemove.bucket &&
            pointers[0].id === pointerToRemove.id) {
            return [];
        }
    }
    else {
        var index = pointers.findIndex(function (pausedRef) {
            return pausedRef.bucket === pointerToRemove.bucket &&
                pausedRef.id === pointerToRemove.id;
        });
        if (index !== -1) {
            var result = pointers.slice();
            result.splice(index, 1);
            return result;
        }
    }
    return pointers;
}
//# sourceMappingURL=changeTracker.js.map